class SubscriptionTotalPrice implements ng.IComponentController {
    totalPrice: number;
    fullPrice: number;
}

angular.module('animatronApp.SubscriptionTotalPrice', [])
    .component('subscriptionTotalPrice', {
        bindings: {
            totalPrice: '<',
            fullPrice: '<'
        },
        controller: SubscriptionTotalPrice,
        templateUrl: require('settings/subscription/subscription-total-price.html')
    });



// WEBPACK FOOTER //
// ./app/assets/javascripts/settings/subscription/SubscriptionTotalPrice.ts